import useBedbankRates from 'hooks/useBedbankRates'

export function canUseBedbankSelectedDates(selectedDatesAndRoomsFilter?: App.OfferListFilters): boolean {
  return !!selectedDatesAndRoomsFilter?.rooms && !!selectedDatesAndRoomsFilter?.checkIn && !!selectedDatesAndRoomsFilter?.checkOut
}

function useBedbankSelectedDatesRates(offerId: string, selectedDatesAndRoomsFilter?: App.OfferListFilters) {
  return useBedbankRates(
    offerId,
    selectedDatesAndRoomsFilter?.rooms,
    selectedDatesAndRoomsFilter?.checkIn,
    selectedDatesAndRoomsFilter?.checkOut,
    canUseBedbankSelectedDates(selectedDatesAndRoomsFilter),
  )
}

export default useBedbankSelectedDatesRates
